import { IPublicClientApplication } from '@azure/msal-browser';
import { AwardGroupQueries } from '../../models/queries-type';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getAdminAwardGroups, getAwardGroups } from './index';

export const createAwardGroupsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAwardGroups: (instance: IPublicClientApplication, awardGroupQueries?: AwardGroupQueries) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardGroups(fetchContext, awardGroupQueries, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardGroups', isInFlight);
    },
  ),
  getAdminAwardGroups: (instance: IPublicClientApplication, awardGroupQueries?: AwardGroupQueries) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAdminAwardGroups(fetchContext, awardGroupQueries, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAdminAwardGroups', isInFlight);
    },
  ),
});
